export default "__VITE_ASSET__BYpiWWDj__"